// extracted by mini-css-extract-plugin
module.exports = {"contentHolder":"CreditTransfer_contentHolder__1u3Iz","FormHolder":"CreditTransfer_FormHolder__2KjO4","ButtonHolder":"CreditTransfer_ButtonHolder__3VD_g"};